import { Zap } from "lucide-react";

const UrgencyStrip = () => (
  <section className="mx-auto mt-16 max-w-3xl px-4 sm:px-6">
    <div className="flex items-center gap-5 rounded-2xl bg-zinc-900 px-6 py-7 sm:px-9">
      <Zap className="h-7 w-7 shrink-0 fill-yellow-200 text-yellow-400" />
      <div>
        <p className="font-bold text-base text-white">
          Your competitors are already posting AI content daily.
        </p>
        <p className="mt-1 text-sm text-white/55 leading-relaxed">
          Every day without it is reach you're not getting back. The algorithm rewards
          consistency — not talent.
        </p>
      </div>
    </div>
  </section>
);

export default UrgencyStrip;
